import { REHYDRATE } from 'redux-persist';
import { CREATE_CATEGORY_SUCCESS, LOGGED_OUT } from 'actions/types';
import * as localTypes from '../actions/types';
const initialState = {
    isFetchingBudgets: false,
    budgets: [],
    budgetsCreatedAt: undefined,
};
const budgeting = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const { budgeting } = action.payload || {};
            if (budgeting) {
                return {
                    ...budgeting,
                    budgets: budgeting.budgets || [],
                    isFetchingBudgets: false,
                };
            }
            return initialState;
        }
        case localTypes.GET_BUDGETS_REQUEST:
            return { ...state, isFetchingBudgets: true };
        case localTypes.GET_BUDGETS_FAILURE:
            return {
                ...state,
                isFetchingBudgets: false,
            };
        case localTypes.SAVE_BUDGETS_SUCCESS: {
            const newMonthlyBudget = action.extra.data['overall.monthly'];
            if (newMonthlyBudget?.baseLimit === null) {
                return {
                    ...state,
                };
            }
            const newBudgets = state.budgets.map((budget) => {
                const newBudget = action.extra.data[budget.key];
                if (!newBudget)
                    return budget;
                return {
                    ...budget,
                    ...newBudget,
                    totalLimit: newBudget?.baseLimit !== undefined
                        ? newBudget?.baseLimit
                        : budget.totalLimit,
                };
            });
            return { ...state, budgets: newBudgets };
        }
        case CREATE_CATEGORY_SUCCESS: {
            const overallLimit = state.budgets.find((budget) => budget.key === 'overall.monthly');
            // todo this illustrates well how we could normalise categories, we have data duplicated all over
            return {
                ...state,
                budgets: [
                    ...state.budgets,
                    {
                        categoryId: action.payload.category.id,
                        displayName: action.payload.category.displayName,
                        color: action.payload.category.color ?? null,
                        emoji: action.payload.category.emoji,
                        currency: overallLimit?.currency || action.extra.currency || 'GBP',
                        parentCategoryId: action.payload.category.parentCategoryId,
                        currentValue: 0,
                        key: `category.${action.payload.category.id}`,
                        baseLimit: null,
                        totalLimit: null,
                        previousAverage: 0,
                        previousPeriodAverage: 0,
                        shouldRollover: null,
                        rollingAccumulatedLimit: null,
                        type: 'category',
                    },
                ],
            };
        }
        case localTypes.GET_BUDGETS_SUCCESS: {
            const { budgets, createdAt } = action.payload;
            let overallPreviousAverageSum = 0;
            let overallPreviousPeriodAverageSum = 0;
            for (let x = 0; x < budgets.length; x++) {
                if (budgets[x].type === 'category') {
                    const roundedPreviousPeriodAverage = Math.round((Math.abs(budgets[x].previousPeriodAverage || 0) +
                        Number.EPSILON) *
                        100) / 100;
                    const roundedPreviousAverage = Math.ceil(Math.abs(budgets[x].previousAverage) / 5) * 5;
                    budgets[x].previousAverage = roundedPreviousAverage;
                    budgets[x].previousPeriodAverage = roundedPreviousPeriodAverage;
                    overallPreviousAverageSum += roundedPreviousAverage;
                    overallPreviousPeriodAverageSum += roundedPreviousPeriodAverage;
                }
                // Budgets.shouldRollover is a 0/1 number, so it needs to be converted to a boolean first
                budgets[x].shouldRollover =
                    budgets[x].shouldRollover != null
                        ? Boolean(budgets[x].shouldRollover)
                        : budgets[x].shouldRollover;
            }
            const budgetsWithOverallAvgSum = budgets.map((budget) => {
                if (budget.key === 'overall.monthly') {
                    return {
                        ...budget,
                        periodAverage: Math.ceil(overallPreviousAverageSum / 10) * 10,
                        previousPeriodAverage: Math.round((overallPreviousPeriodAverageSum + Number.EPSILON) * 100) / 100,
                    };
                }
                return budget;
            });
            return {
                ...state,
                budgets: budgetsWithOverallAvgSum,
                budgetsCreatedAt: createdAt,
                isFetchingBudgets: false,
            };
        }
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default budgeting;
